const tichengPage3 = () => import('@/views/main/performance-commission/ticheng3/ticheng.vue')
export default {
  path: '/main/tichengPage3',
  name: 'tichengPage3',
  component: tichengPage3,
  children: []
}
